import { NodeValidationState } from "@features/builder/graph/nodes/validation/types"
import { AppNode } from "@features/builder/graph/types"
import { NodesMapper } from "@features/builder/helpers/nodesMapper"
import { validateTokens } from "@features/builder/NodeDrawer/NodeForm/NodeExpressionAccordion/expressionLinter"

export function validateNodeExpression(node: AppNode, mapper: NodesMapper): NodeValidationState {
  if (!("originalNode" in node.data))
    return { EXPRESSION_LINTING: { status: "unknown", errors: [] } }

  const expression = node.data.originalNode.properties.df_cpd.expression?.[0] ?? ""
  const diagnostics = validateTokens(expression, node, mapper)

  return {
    EXPRESSION_LINTING: diagnostics.length
      ? { status: "error", errors: [{ msg: "Invalid expression" }] }
      : { status: "valid", errors: [] },
  }
}
